import { render, staticRenderFns } from "./VisitRecomendationObs.vue?vue&type=template&id=71a829fe"
import script from "./VisitRecomendationObs.vue?vue&type=script&lang=js"
export * from "./VisitRecomendationObs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports